import React from 'react';

import { Link } from './styles';
import { Button } from './styles';

export const Btn = ({ as, children, ...rest }) => {
  return <>{as === 'a' ? <Link {...rest}>{children}</Link> : <Button {...rest}>{children}</Button>}</>;
};
